import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Fab } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';

const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible || !document.body) return null;

  return createPortal(
    <Fab
      onClick={scrollToTop}
      color="primary"
      size="medium"
      sx={{
        position: 'fixed !important',
        bottom: '20px !important',
        right: '20px !important',
        zIndex: 9999,
        '&:hover': {
          transform: 'scale(1.1)',
        },
      }}
      aria-label="scroll back to top"
    >
      <KeyboardArrowUp />
    </Fab>,
    document.body
  );
};

export default BackToTop;